import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useState } from 'react';

interface DiscordButtonProps {
  size?: number;
  text?: string;
}
const DiscordButton = (props: DiscordButtonProps) => {
  const { size = 35, text = '' } = props;
  const [open, setOpen] = useState(false);
  const showDiscord = process.env.NEXT_PUBLIC_DISPLAY_DISCORD_SERVER === 'true';
  if (!showDiscord) {
    return null;
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const discordInviteLink = process.env.NEXT_PUBLIC_DISCORD_JOIN_URL;

  return (
    <>
      <Button
        onClick={handleClickOpen}
        sx={{
          background: 'linear-gradient(rgb(82, 101, 246) 0%, rgb(67, 82, 202))',
          borderRadius: '500px',
          // boxShadow:
          // 'rgba(0, 0, 0, 0.13) 0px 0.5px 1px -0.3px, rgba(0, 0, 0, 0.13) 0px 1.3px 3px -0.6px,rgba(0, 0, 0, 0.13) 0px 3px 7px -1px,rgba(0, 0, 0, 0.13) 0px 6px 14px -1.5px, rgba(0, 0, 0, 0.13) 0px 14px 30px -2px',
          boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.3)',
          padding: size * 0.025,
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          width: text ? '100%' : size,
          minWidth: text ? '100%' : size,
          height: size,
          '&:hover': {
            filter: 'brightness(1.2)',
          },
        }}
      >
        <Box
          component="img"
          src="/images/discord.svg"
          alt="AlloClients"
          sx={{
            objectFit: 'contain',
            cursor: 'pointer',
            maxWidth: size * 0.8,
            maxHeight: size * 0.8,
          }}
        />
        {text && (
          <Typography variant="body1" sx={{ color: 'common.white', ml: 1, whiteSpace: 'nowrap' }}>
            {text}
          </Typography>
        )}
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="discord-dialog-title"
        aria-describedby="discord-dialog-description"
      >
        <DialogTitle id="discord-dialog-title">Rejoignez la communauté Discord</DialogTitle>
        <DialogContent>
          <DialogContentText id="discord-dialog-description">
            <Typography variant="body1" sx={{ mb: 2 }}>
              Discord, c'est l'endroit pour échanger avec la communauté :
            </Typography>

            <Typography variant="body1" sx={{ mb: 1 }}>
              - Poser vos questions,
            </Typography>

            <Typography variant="body1" sx={{ mb: 1 }}>
              - Infos importantes,
            </Typography>

            <Typography variant="body1" sx={{ mb: 1 }}>
              - Retours d’expérience,
            </Typography>

            <Typography variant="body1" sx={{ mb: 1 }}>
              - Conseils utiles.
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Fermer</Button>
          <Button
            href={discordInviteLink || ''}
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            autoFocus
          >
            Rejoindre (en 30s)
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DiscordButton;
